import React from "react";

/**
 * MARSH. wordmark — matches the brand.
 * Uses <foreignObject>-free pure SVG text. Dot sits flush to the "H".
 *
 * Height-based sizing: prop `size` is the height in px. Width scales to preserve ratio.
 */
export default function Logo({ light = false, size = 24 }) {
  const ink = light ? "#FDFBF7" : "#242321";
  const dot = "#C9A24A"; // warm gold
  // ViewBox tuned so the wordmark + dot sit comfortably with tiny bleed
  return (
    <svg
      viewBox="0 0 270 60"
      style={{ height: size, width: "auto", display: "block" }}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Marsh Clothing"
    >
      <text
        x="2"
        y="46"
        fontFamily='"Manrope","Helvetica Neue",Arial,sans-serif'
        fontWeight="800"
        fontSize="52"
        letterSpacing="1"
        fill={ink}
        textLength="235"
        lengthAdjust="spacingAndGlyphs"
      >
        MARSH
      </text>
      <circle cx="252" cy="46" r="7" fill={dot} />
    </svg>
  );
}
